export const templateState = {
  templates: null,
  selectedBookingTemplate: null,
  templateDetails: [],
};